import { bulkRestaurantProductsCategory } from "../actions";
import { IBulkActionModal } from "../interfaces";

import { Box } from "@mui/material";
import useRequest from "api/useRequest";
import { modalHide } from "app/App/actions";
import CategoriesFormSelect from "app/Categories/components/CategoriesFormSelect";
import { AxiosResponse } from "axios";
import trans from "helpers/trans";
import { FC, useRef } from "react";
import { useDispatch } from "react-redux";
import {
    Button,
    Form,
    Modal,
    ModalActions,
    ModalContent,
    ModalTitle,
} from "ui";
import { IGPFormRef } from "ui/Form/Form";

const BulkCategoryModal: FC<IBulkActionModal> = ({ selected, onSuccess }) => {
    const dispatch = useDispatch();
    const formRef = useRef<IGPFormRef | null>();

    const { currentData, request, errors, isLoading, isSuccess } = useRequest();

    const handleCloseModal = () => {
        dispatch(modalHide("BulkCategoryModal"));
    };

    const handleSubmit = () => {
        if (formRef.current !== null) {
            const data: any = formRef?.current?.getData();
            request(
                bulkRestaurantProductsCategory(
                    {
                        ...data,
                        ids: selected,
                    },
                    (response: AxiosResponse) => {
                        if (response.status === 204) {
                            dispatch(modalHide("BulkCategoryModal"));
                            onSuccess();
                        }
                    }
                )
            );
        }
    };

    return (
        <Modal open fullWidth maxWidth="sm">
            <ModalTitle onClose={handleCloseModal}>
                {" "}
                {trans("inv.restaurantProducts.modal.BulkCategoryModal.title")}
            </ModalTitle>
            <ModalContent>
                <Form
                    ref={formRef}
                    data={currentData}
                    errors={errors}
                    fields={{
                        category_id: { default: "" },
                    }}
                    loading={isLoading}
                    onSubmit={handleSubmit}
                    onSuccess={isSuccess}
                    unsaved={false}
                >
                    <CategoriesFormSelect id="category_id" fullWidth />
                </Form>
            </ModalContent>
            <ModalActions>
                <Box display="flex" width="100%" textAlign="right">
                    <Button
                        onClick={handleCloseModal}
                        color="inherit"
                        variant="text"
                        sx={{ mr: 1 }}
                    >
                        {trans("global.button.cancel")}
                    </Button>
                    <Button sx={{ flex: 1 }} onClick={handleSubmit}>
                        {trans("global.button.save")}
                    </Button>
                </Box>
            </ModalActions>
        </Modal>
    );
};

export default BulkCategoryModal;
